;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesAbout = View.LeaguesAbout.extend({
		template: JST.TippingLeaguesAbout,
		ui:       {
			'leave_btn': '.js-leave',
			'show_more': '.js-load-more',
			'search':    '.js-search-member'
		},

		leaveLeague:     function () {
			this.showPreloader();

			if(this.model.get('is_user_joined')) {
				this.league.leave();
			} else {
				this.hidePreloader();
			}

			return this;
		},
	});

}(window, APP, Backbone, Marionette, $, _));